import { render, staticRenderFns } from "./InstagramModal.vue?vue&type=template&id=317347b2&scoped=true"
import script from "./InstagramModal.vue?vue&type=script&lang=js"
export * from "./InstagramModal.vue?vue&type=script&lang=js"
import style0 from "./InstagramModal.vue?vue&type=style&index=0&id=317347b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317347b2",
  null
  
)

export default component.exports